import { render } from "./DialogPurchaseVersionWarning.vue?vue&type=template&id=21ef6c9a&scoped=true"
import script from "./DialogPurchaseVersionWarning.vue?vue&type=script&lang=js"
export * from "./DialogPurchaseVersionWarning.vue?vue&type=script&lang=js"

import "./DialogPurchaseVersionWarning.vue?vue&type=style&index=0&id=21ef6c9a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-21ef6c9a"

export default script